module.exports = __webpack_public_path__ + "img/saude.f60005bd.svg";